
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  Cameras: '摄像头',
  Playback: '回放',
  Events: '消息',
  allDevices: '所有设备',
  Connected: '已连接',
  noConnected: '未连接',
  SelectDate: '日期选择',
  Holdspeak: '点击对讲',
  ClicktoStopInterc: '点击停止对讲',
  ClicktoInterc: '点击开始对讲',
  NoiseReduction: '降噪',
  SoundVolume: '音量',
  ManualAlarm: '人工报警',
  Sound: '声音',
  Light: '灯光',
  SoundLight: '声音和灯光',
  SoundDetail: '触发报警并播放声音，\n报警会在30秒后自动关闭。',
  LightDetail: '触发报警并闪烁灯光，\n报警会在30秒后自动关闭。',
  SoundLightDetail: '触发报警并播放声音和闪烁灯光.\n报警会在30秒后自动关闭。',
  set: {
    es: '事件设置',
    rs: '录像设置',
    as: '声音设置',
    gs: '通用',
    sd: '设备分享'
  },
  cmodel: '型号 ',
  name: '设备名称',
  BatteryLevel: '电池电量',
  cfu: '检查更新',
  RestartDevice: '重启设备',
  DeleteDevice: '删除设备',
  RemoveDevice: '移出设备',
  Copied: '复制成功',
  CopyFailed: '复制失败',
  SpotlightSettings: '灯光设置',
  MotionDetection: '运动侦测',
  VideoSettings: '视频设置',
  AudioSettings: '声音设置',
  Notification: '消息',
  GeneralSettings: '通用',
  Settings: '设置',
  ViewAccount: '账号预览',
  MyService: '我的服务',
  AdditionalService: '附加服务',
  DeviceShare: '设备分享',
  LabFeature: '实验功能',
  HelpFeedback: '帮助和反馈',
  DarkMode: '深色模式',
  DeviceDisplayOrder: '显示顺序',
  Region: '地区',
  About: '关于',
  AccountSettings: '账号设置',
  RNPU: '接受版本更新通知',
  Email: '邮箱',
  ChangePassword: '修改密码',
  SignOut: '退出登录',
  Passwordlogin: '密码登录',
  Accountnumber: '账号',
  UEMnumber: '用户名/邮箱/手机号',
  pwd: '密码',
  Ipwd: '请输入密码',
  Forgotpassword: '忘记密码？',
  Login: '登录',
  Lac: 'Login and consent the <i>Terms of Service</i>, <i>Terms of Use</i>,<br> <i>Privacy Policy</i> and <i>Data Policy</i>.',
  MVCL: '手机验证码登录',
  APL: '账号密码登录',
  Mobilelogin: '手机号登录',
  Mobilenumber: '手机号',
  VC: '验证码',
  IVC: '亲输入收到的验证码',
  IMN: '亲输入您的手机号',
  GVC: '获取验证码',
  HBS: '验证码已发送',
  Signup: '注册',
  PETE: '亲输入您的邮箱地址',
  PEMN: '亲输入您的手机号',
  Iat: 'I agree to the <i>Terms of Service</i>, <i>Terms of Use</i>, <i>Privacy <br> Policy</i> and <i>Data Policy</i>.',
  Rpwd: '找回密码',
  FAR: '请输入要找回的账号',
  EMP: '邮箱 / 手机号',
  Confirm: '确认',
  npwd: '新密码',
  inpwd: '请输入新密码',
  cnpwd: '确认密码',
  inpwda: '请再次输入密码',
  AddDevice: '添加设备',
  next: '下一步',
  icontip: {
    pre: '上一个视频',
    xyz: '下一帧',
    suspend: '暂停/播放',
    next: '下一个视频',
    refresh: '刷新视频',
    ptz: '方向控制',
    speak: '语音对讲',
    alarm: '手动报警',
    light: '灯光设置',
    quality: '画质',
    jietu: '视频截图',
    video: '视频录制',
    set: '摄像头设置',
    clos: '静音开关',
    dld: '下载',
    speed: '播放速度',
    full: '全屏播放'
  },
  Fluent: '流畅',
  SD: '标准',
  QHD: '高清',
  RandS: '旋转与缩放',
  umwsv: '使用鼠标滚轮缩放画面',
  NDY: '暂无设备',
  PEDU: '请输入设备UID',
  DU: '设备UID',
  Cancel: '取消',
  Add: '添加',
  CNSD: '连接成功',
  Connecting: '连接中',
  mediaerr: '您的浏览器暂不支持录音功能',
  LTO: '灯光已打开',
  LTOF: '灯光已关闭',
  SetupMode: '模式设置',
  PSWF: '请选择一个wifi网络',
  PBT: '请按住SYNC按钮2秒，直到LED灯闪蓝灯且听到一声提示音',
  UDS: '请用您的设备扫描上面的二维码，扫描成功后您将会听到两声提示音',
  Delete: '删除',
  Restart: '重启',
  aysrs: '您确定要重启该设备吗？',
  drpw: '设备重启中，请等待几分钟。',
  aydd: '您确定要删除该设备吗？',
  arusd: '您确定要删除吗？',
  salot: '请至少选择一项',
  AboutDevice: '关于设备',
  EventsSettings: '事件设置',
  RecordingSettings: '录像设置',
  MAT: '事件提示音',
  OHAM: '白天只记录和推送人类活动，晚上记录和推送所有事件。',
  HO: '仅记录人类活动',
  AM: '记录所有活动',
  AMR: '所有时段记录和推送所有事件',
  asea: '编辑保存后，运动侦测被触发时，编辑区域将会闪烁红色。',
  NightVision: '夜间模式',
  bwnv: '黑白模式',
  irled: '在夜间检测到运动时，红外状态灯将打开。',
  cnv: '彩色模式',
  atsw: '在夜间检测到运动时,聚光灯将会自动开启以录制彩色视频，但会增大电量消耗。',
  TurnOff: '关闭',
  tfled: '在夜间关闭红外灯和聚光灯。',
  Storage: '本地储存',
  ModifyName: '修改设备名称',
  CameraName: '摄像机名称',
  nfmt: '输入2~30个长度，支持中文、英文和数字',
  UpdateFirmware: '固件更新',
  tnv: '新版本',
  adyc: '可以下载安装，当前版本是',
  InstallUpdates: '安装更新',
  cv: '当前版本是',
  ntd: '，是最新版本。',
  LogoWaterMark: '水印图标',
  Definition: '分辨率',
  FIR: '水印',
  dnuv: '在视频右上角显示水印文字。',
  RemarkName: '水印文字',
  Save: '保存',
  mcp: '话筒(输入)',
  hsar: '对讲和声音录制', // Hold & Speak sound, Audio recording sound
  Speaker: '扬声器(输出)',
  WiFiC: 'Wi-Fi 连接',
  SLED: 'LED灯状态',
  MountingGuide: '安装指引',
  LocalStorage: '本地储存',
  Video: '视频数据',
  Available: '可使用',
  Format: '格式化',
  ShareDevice: '设备分享',
  flmrs: '格式化本地存储卡会删除已保存的所有数据。',
  ut2s: '最多可编辑2个活动区域',
  dts: '侦测敏感度',
  dtt: '侦测类型',
  sea: '保存编辑',
  Low: '低',
  Medium: '中',
  High: '高',
  ea1: '编辑区域 1',
  ea2: '编辑区域 2',
  ActivityZone: '活动区域',
  EventAlarm: '事件告警',
  CameraAlarm: '摄像头报警',
  Alarmsound: '报警音量：',
  AlarmDuration: '铃响时长：',
  dsaw: '设置一个您想要侦测的特定区域。',
  Brightness: '亮度：',
  VideoRecording: '录制视频',
  AudioRecording: '录制声音',
  CustomizeRecording: '自定义设置',
  vpses: '视频声音，事件报警音',
  RestoreDefault: '恢复默认',
  Cliplength: '录制时长：',
  ibt: '录制间隔：',
  dywqc: '您确定要放弃更改吗？',
  sdoh: '选择设备或者家庭组',
  mh: '我的家庭组',
  anh: '新建家庭组',
  shl: '设置家庭组位置',
  hifm: '家庭组信息',
  aystr: '您确定要移除此家庭组吗?',
  aystrr: '你确定要移除该名成员吗?',
  aystl: '您确定要离开此家庭组吗?',
  rmdfst: '请先移除家庭组所以设备再就行此操作.',
  hnn: '家庭组名称',
  mndv: '设备管理',
  oprsd: '操作成功',
  Invite: '邀请新成员',
  sihss: '邀请信息已成功发送.',
  ssd: '选择需要分享的设备',
  uifm: '成员信息',
  aysuds: '您确定要移除该设备吗? ',
  dywup: '你确定要将该成员升级到最高权限吗?',
  Sddvc: '分享的设备',
  ManageHome: '家庭组管理',
  devices: '设备',
  members: '成员',
  creator: '创建者',
  dName: '名称',
  Address: '地址',
  plen: '请输入名称',
  plea: '请输入地址',
  hrid: '家庭成员',
  owner: '拥有者',
  waiting: '待同意',
  adrd: '添加新成员',
  lvhm: '离开家庭组',
  rmhm: '移除家庭组',
  mvdvc: '移动设备',
  invitation: '邀请',
  etth: '请输入你要分享的',
  ywts: '',
  EmailAddress: '邮箱地址',
  fmtiv: '格式不正确',
  Sdivt: '发送邀请',
  Administrators: '管理员',
  ivff: '邀请朋友或家人',
  viewers: '观看者',
  sspm: '选择一个分享的权限',
  OK: '好',
  ...zhLocale
}



// WEBPACK FOOTER //
// ./src/locales/zh.js